import { IApiPictureResponse } from 'affiny-core/modules/api/models/picture/picture.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const PicturesResource = {
  postPicture: (type: string, blob: string) =>
    AffinyEndpoint.Pictures.url(`/`)
      .post({
        data: {
          attributes: {
            type,
            blob,
          },
        },
      })
      .json<IApiPictureResponse>(),
  deletePicture: (id: string) =>
    AffinyEndpoint.Pictures.url(`/${id}/`).delete().res(),
  postMainPicture: (id: string) =>
    AffinyEndpoint.Pictures.url(`/${id}/set_as_main`).post().res(),
};
